<template>
  <div>
    <v-row>
      <v-col cols="11">
        <h4 class="primary--text font-weight-medium">
          {{ $t('display/advert:edit.titles.regions') }}
        </h4>
      </v-col>
      <v-col cols="1">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">help_outline</v-icon>
          </template>
          <span>{{$t('display/advert:edit.description.regions')}}</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <!-- Region of playing -->
    <v-treeview
      selectable
      item-disabled="locked"
      :items="translatedRegion"
      item-text="name"
      item-value="id"
      v-model="model"
    />
  </div>
</template>

<script>
import Utils from '@/modules/core/services/utils';
import AdvertService from '@/modules/display/services/advert-service';

export default {
  name: "RegionsComponent",
  props: {
    selectedRegions: String
  },
  data() {
    return {
      regions: [],
      rawRegions: [],
      globalCityCount: 0,
      provinceCount: new Map(),
      model: [],
      allRegion: true,
      allSelectedCities: []
    }
  },
  computed: {
    translatedRegion() {
      if (this.regions.length === 0) return [];
      let translatedRegions = [];

      for (let i = 0; i < this.regions.length; i++) {
        let translatedRegion = {
          id: this.regions[i].id,
          name: this.$t(`country:${this.regions[i].name}.country`)
        };

        let provinces = this.regions[i].children;
        let translatedProvinces = [];
        for (let j = 0; j < provinces.length; j++) {
          let translatedProvince = {
            id: provinces[j].id,
            name: this.$t(`country:${this.regions[i].name}.provinces.${provinces[j].name}`),
            children: provinces[j].children,
            count: provinces[j].count
          }
          translatedProvinces.push(translatedProvince);
        }
        translatedRegion.children = translatedProvinces;
        translatedRegion.count = this.regions[i].count;
        translatedRegions.push(translatedRegion)
      }

      return translatedRegions;
    }
  },
  created() {
    AdvertService.readAllRegionsCount(
      (response) => {
        this.rawRegions = response.data;
        for (var i = 0; i < response.data.length; i++) {
          let country =
            Object.assign(
              {
                id: response.data[i].country_id,
                name: response.data[i].country_name.toLowerCase(),
              },
              this.getCountryProvinces(response.data[i]));
          this.regions.push(country);
        }
        if (this.allRegion) {
          this.model = this.allSelectedCities;
        }
      },
      () => {
        Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/advert:edit.snackbar.regions')}));
      }
    )
  },
  methods: {
    init(regions) {
      let selectedRegions = this.parseJson(regions);
      this.model = this.allSelectedCities;

      if (selectedRegions.length > 0) {
        let resultModel = [];
        for (let i = 0; i < selectedRegions.length; i++) {
          resultModel = resultModel.concat(this.convertCountryToArray(selectedRegions[i]));
        }

        this.model = resultModel;
      }

    },
    parseJson(regions) {
      if (regions === null) {
        return [];
      }

      try {
        return JSON.parse(regions);
      } catch (e) {
        return [];
      }
    },
    convertCountryToArray(country) {
      if (!country) return [];
      if (country['filter_flag'] === 1) {
        return this.convertProvinceToArray(country.country_id);
      }

      return this.convertProvinceToArray(country.country_id, country.provinces);
    },
    getProvinceForConvert(countryId, provinceId) {
      let regions = this.regions;
      let country = {};
      let result = [];
      for (let i = 0; i < regions.length; i++) {
        if (regions[i].id == countryId) {
          country = regions[i];
          break;
        }
      }
      result = country.children;

      if (typeof provinceId !== 'undefined') {
        for (let i = 0; i < country.children.length; i++) {
          if (country.children[i].id === provinceId) {
            result = country.children[i];
            break;
          }
        }
      }

      return result;
    },
    convertProvinceToArray(countryId, provinces) {
      var cities = [];
      if (typeof provinces === 'undefined') {
        let country = this.getProvinceForConvert(countryId);
        for (let i = 0; i < country.length; i++) {
          cities = cities.concat(this.convertCityToArray(country[i].children))
        }

        return cities;
      }

      for (let i = 0; i < provinces.length; i++) {
        if (provinces[i]['filter_flag'] === 1) {
          cities = cities.concat(
            this.convertCityToArray(
              this.getProvinceForConvert(countryId, provinces[i]['province_id']).children
            )
          );
        } else {
          cities = cities.concat(
            this.convertCityToArray(provinces[i]['cities'], provinces[i]['province_id'])
          );
        }
      }

      return cities;
    },
    convertCityToArray(cities, provinceId) {
      let result = [];
      if (typeof provinceId === 'undefined') {

        for (let i = 0; i < cities.length; i++) {
          result.push(cities[i].id);
        }
        return result;
      }

      for (let i = 0; i < cities.length; i++) {
        result.push(provinceId + '#' + cities[i]);
      }

      return result;
    },
    getCountryProvinces(country) {
      if (typeof country.provinces === 'undefined') {
        return {};
      }

      let provinces = [];
      let provincesCityCount = 0;
      for (let i = 0; i < country.provinces.length; i++) {
        let provinceCities = this.getCities(country.provinces[i]);
        provincesCityCount += provinceCities.count;
        let provinceName = country.provinces[i].province_name.toLowerCase().replace(' ', '-');
        provinces.push(
          Object.assign(
            {
              id: country.provinces[i].province_id,
              name: provinceName
            },
            provinceCities
          )
        );
      }
      
      return  {
        children: provinces,
        count: provincesCityCount
      };
    },

    getCities(province) {
      if (typeof province.city_counts === 'undefined') {
        return {};
      }

      let cities = [];
      let cityCount = 0;
      for (let i = 0; i < province.city_counts.length; i++) {
        cities.push({
          id: `${province.province_id}#${province.city_counts[i].city_name}`,
          name: `${province.city_counts[i].city_name} (${province.city_counts[i].count})`
        });
        this.allSelectedCities.push(`${province.province_id}#${province.city_counts[i].city_name}`);
        this.globalCityCount++;
        cityCount++;
      }
      let result = {
        children: cities,
        count: cityCount
      };

      this.provinceCount.set(province.province_id, cityCount);

      return result;
    },

    updateFilterFlag(regions) {

      for (let i = 0; i < regions.length; i++) {
        if (this.isFullCountry(regions[i].provinces, regions[i].country_id)) {
          regions[i].filter_flag = 1;
          regions[i].provinces = [];
        }
      }

      return regions;
    },

    isFullCountry(provinces, countryId) {
      let isFullCountry = provinces.length === this.getProvinceCountByCountryId(countryId);

      for(let i = 0; i < provinces.length; i++) {
        let provinceCount = this.provinceCount.get(provinces[i].province_id);
        if (provinceCount === provinces[i].cities.length) {
          provinces[i].cities = [];
          provinces[i].filter_flag = 1;
        } else {
          isFullCountry = false;
        }
      }

      return isFullCountry && provinces.length > 0;
    },

    getProvinceCountByCountryId(countryId) {
      for(let i = 0; i < this.rawRegions.length; i++) {
        if (countryId === this.rawRegions[i].country_id) {
          return this.rawRegions[i].provinces.length;
        }
      }
    },

    getRegionStructureForFilter(cities) {
      let region = [];
      for(let i = 0; i < cities.length; i++) {
        let cityData = cities[i].split('#');
        region = this.mergeTwoStructure(region, this.getProvinceStructure(cityData[0], cityData[1]));
      }

      return this.updateFilterFlag(region);
    },

    getProvinceStructure(provinceId, city) {
      for (let countryIt = 0; countryIt < this.rawRegions.length; countryIt++) {
        let provinces = this.rawRegions[countryIt].provinces;
        for(let provinceIt = 0; provinceIt < provinces.length; provinceIt++) {
          let province = provinces[provinceIt];
          if (province.province_id == provinceId) {
            let country = {
              country_id: this.rawRegions[countryIt].country_id,
              country_name: this.rawRegions[countryIt].country_name,
              filter_flag: 0
            };
            let resultProvince = {
              filter_flag: 0,
              province_id: province.province_id,
              province_name: province.province_name,
              cities: [city]
            }
            country.provinces = [resultProvince];
            return [country];
          }
        }
      }
    },

    mergeTwoStructure(obj1, obj2) {
      for (let attr in obj2) {
        if (typeof obj1[attr] === 'undefined') {
          obj1[attr] = obj2[attr];
          continue;
        }

        let firstAttr = this.getCorrectIndex(obj1, obj2[attr].country_id);
        firstAttr = firstAttr > 0 ? firstAttr : attr;

        if(obj1[firstAttr].country_id === obj2[attr].country_id) {
          obj1[firstAttr].provinces = this.mergeProvinces(obj1[firstAttr].provinces, obj2[attr].provinces)
        } else {
          obj1.push(obj2[attr]);
        }
      }

      return obj1;
    },

    mergeProvinces(provinces1, provinces2) {
      for (let i = 0; i < provinces2.length; i++) {
        if (typeof provinces1[i] === 'undefined') {
          provinces1[i] = provinces2[i];
        }

        let firstProvinceIndex = this.getCorrectProvinceIndex(provinces1, provinces2[i].province_id);
        firstProvinceIndex = firstProvinceIndex > 0 ? firstProvinceIndex : i;

        if( provinces1[firstProvinceIndex].province_id == provinces2[i].province_id) {
          provinces1[firstProvinceIndex].cities = [].concat(provinces1[firstProvinceIndex].cities, provinces2[i].cities);
          provinces1[firstProvinceIndex].filter_flag = provinces2[i].filter_flag;
          provinces1[firstProvinceIndex].province_id = provinces2[i].province_id;
        } else {
          provinces1.push(provinces2[i]);
        }
      }
      return provinces1;
    },

    getCorrectIndex(firstStructure, countryId) {
      for (let i = 0; i < firstStructure.length; i++) {
        if (firstStructure[i].country_id == countryId) {
          return i;
        }
      }

      return -1;
    },

    getCorrectProvinceIndex(provinces, provinceId) {
      for (let i = 0; i < provinces.length; i++) {
        if (provinces[i].province_id == provinceId) {
          return i;
        }
      }

      return -1;
    }


  },
  watch: {
    model() {
      let region = this.getRegionStructureForFilter(this.model);
      this.$emit('regionUpdated', region);
      if (region.length === 0) {
        this.allRegion = false;
      } else if (this.model.length === this.allSelectedCities.length) {
        this.allRegion = true;
      }
    },
    allRegion() {
      if (this.allRegion) {
        this.model = this.allSelectedCities;
      } else {
        this.model = [];
      }
    }
  }
}
</script>